module.exports = __webpack_public_path__ + "img/photo-header.9330fdc9.jpg";